export const BACKEND_MODE = String(import.meta.env.VITE_BACKEND_MODE || "local").toLowerCase();
export const backendEnabled = BACKEND_MODE === "remote";
